import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import type { PlanId } from '../pages/SalesPage';
interface FinalCtaProps {
  selectedPlan: PlanId;
  onBuy: () => void;
}
export function FinalCta({
  selectedPlan,
  onBuy
}: FinalCtaProps) {
  const planLabel = selectedPlan === 'pro' ? 'Pack PRO — $29.900' : 'MegaKit — $19.900';
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-950 text-center relative overflow-hidden" data-id="element-104">
      <div className="absolute inset-0 bg-gold-500/5 rounded-full blur-3xl transform translate-y-1/2" data-id="element-105"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-106">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-cream-50 mb-4 md:mb-6" data-id="element-107">
          No preparés otro encuentro improvisando
        </h2>
        <p className="text-base md:text-xl text-cream-50/80 mb-6 md:mb-8 px-2" data-id="element-108">
          Hoy podés descargar más de 100 actividades y empezar a preparar tu
          próximo encuentro en 10 minutos.
        </p>

        <motion.button whileHover={{
        y: -2,
        boxShadow: '0 6px 20px rgba(200,162,74,0.3)'
      }} whileTap={{
        scale: 0.98
      }} onClick={onBuy} className="w-full sm:w-auto bg-gold-500 hover:bg-gold-600 text-navy-950 font-bold py-4 md:py-5 px-8 md:px-10 rounded-full text-lg md:text-xl shadow-[0_4px_14px_0_rgba(200,162,74,0.39)] transition-colors" data-id="element-109">
          💛 QUIERO MI MEGAKIT AHORA
        </motion.button>
        <p className="text-cream-50/60 text-xs md:text-sm mt-3 font-medium" data-id="element-110">
          Opción seleccionada:{' '}
          <span className="text-gold-500 font-bold" data-id="element-111">{planLabel}</span>
        </p>

        <div className="mt-6 md:mt-8 flex flex-wrap justify-center gap-x-4 md:gap-x-6 gap-y-2 text-xs md:text-sm text-cream-50/60 font-medium" data-id="element-112">
          <span className="flex items-center gap-1" data-id="element-113">
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500" data-id="element-114" /> Acceso
            inmediato
          </span>
          <span className="flex items-center gap-1" data-id="element-115">
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500" data-id="element-116" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-117">
            <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-gold-500" data-id="element-118" /> Pago
            seguro con Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}